// React Third Party Library
import { Typography, Badge, Progress, Row, Col, Popover } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

// Constant
import { TEMPLATE, ROOT_CONSTANT } from "../../../constants";

// Components
import { ButtonLink, Options } from "../../../components";

// Handlers
import { filter } from "../../../handlers";

// Service Library
import { TIME } from "../../../services/util";

const { TABLE_EMPLOYEE_TITLE, TABLE_EMPLOYEE_INDEX, EMPLOYEE_STATUS_TITLE } =
  TEMPLATE.EMPLOYEE;

const { icon_malaysia } = ROOT_CONSTANT.IMG.ICON.COUNTRY;
const { icon_comment } = ROOT_CONSTANT.IMG.ICON;

const { bankList } = Options;

const { parseTimeMin } = TIME;

const { searchHDLR, filterHDLR } = filter;

const { Text } = Typography;

const getProgressColor = (value, eligAmount) => {
  if (value < eligAmount) {
    // green
    return {
      "0%": "#4CAF50",
      "100%": "#204921",
    };
  } else if (value >= eligAmount + 500) {
    // red
    return {
      "0%": "#FF0000",
      "100%": "#990000",
    };
  } else {
    // yellow
    return {
      "0%": "#FFE500",
      "100%": "#FFBA34",
    };
  }
};

const getBankIcon = (bankName) => {
  const matchedBank = bankList.find((bank) => bank.value.name === bankName);
  return matchedBank ? matchedBank.icon : null;
};

const formatIC = (ic) => {
  if (!ic) {
    return "";
  }
  let cleanedIC = ic.replace(/\D/g, "");

  if (cleanedIC.length > 12) {
    cleanedIC = cleanedIC.slice(0, 12);
  }

  if (cleanedIC.length < 12) {
    cleanedIC = cleanedIC.padEnd(12, "_");
  }
  return (
    cleanedIC.slice(0, 6) +
    "-" +
    cleanedIC.slice(6, 8) +
    "-" +
    cleanedIC.slice(8)
  );
};

export const EMPLOYEE_SUMMARY_COL = ({
  redux = {},
  func = {},
  exportState = false,
}) => {
  const { group, user, company = {} } = redux;
  const { handleSearch, DrawerRemark} =
    func;

  const columns = [
    {
      title: TABLE_EMPLOYEE_TITLE.EmployeeID,
      key: TABLE_EMPLOYEE_INDEX.EmployeeID,
      width: 180,
      fixed: "left",
      render: (record) => {
        const { memid } = record;
        return exportState ? memid : <Text>{memid} </Text>;
      },
      ...searchHDLR.getColumnSearchProps("memid", handleSearch),
    },
    {
      title: TABLE_EMPLOYEE_TITLE.Status,
      key: TABLE_EMPLOYEE_INDEX.Status,
      width: 250,
      fixed: "left",
      render: (record) => {
        const { status } = record;

        const { name, colorTag, bgColor } = EMPLOYEE_STATUS_TITLE[status];

        return exportState ? (
          name
        ) : (
          <div
            style={{
              backgroundColor: bgColor,
              display: "inline-block",
              padding: "3px 13px",
              borderRadius: "30px",
            }}
          >
            <Badge
              color={colorTag}
              text={<span style={{ color: colorTag }}>{name}</span>}
            />
          </div>
        );
      },
      filters: filterHDLR.getColumnsFilterStatus(EMPLOYEE_STATUS_TITLE),
      onFilter: (value, record) => record.status === value,
    },
    {
      title: TABLE_EMPLOYEE_TITLE.Name,
      key: TABLE_EMPLOYEE_INDEX.Name,
      width: 200,
      render: (record) => {
        const { name } = record;
        return exportState ? name : <Text>{name} </Text>;
      },
      sorter: true,
      ...searchHDLR.getColumnSearchProps("name", handleSearch),
    },
    ...(user.uroleid === "A"
      ? [
          {
            title: TABLE_EMPLOYEE_TITLE.CoName,
            key: TABLE_EMPLOYEE_INDEX.CoName,
            render: (record) => {
              const { company_name, coid } = record;
      
              const comp = `${company_name || ''}${company_name && coid ? ' /' : ''}${coid || ''}`;
              return exportState ? company_name : <Text>{comp}</Text>;
            },
            filters: filterHDLR.getColumnsFilterType(company),
            onFilter: (value, record) => value.includes(record.coid),
            filterSearch: true,
          },
          ...(exportState
            ? [
                {
                  title: TABLE_EMPLOYEE_TITLE.CoID,
                  width: 200,
                  render: (record) => {
                    const { coid } = record;
                    
                    return exportState ? coid : <Text>{coid}</Text>;
                  },
                  ...searchHDLR.getColumnSearchProps("coid", handleSearch),
                },
              ]
            : []),
        ]
      : []),
    {
      title: TABLE_EMPLOYEE_TITLE.IC,
      key: TABLE_EMPLOYEE_INDEX.IC,
      render: (record) => {
        const { ic } = record;

        const formattedIc = formatIC(ic);

        return exportState ? formattedIc : <>{formattedIc} </>;
      },
      ...searchHDLR.getColumnSearchProps("ic", handleSearch),
    },
    {
      title: TABLE_EMPLOYEE_TITLE.Group,
      key: TABLE_EMPLOYEE_INDEX.Group,
      render: (record) => {
        let { groupName, groupColor } = record;

        if (groupName === undefined || !groupName) {
          groupName = "Ungroup";
          groupColor = "#F5F5F5";
        }

        return exportState ? (
          groupName
        ) : (
          <div
            style={{
              backgroundColor: groupColor,
              display: "inline-block",
              padding: "3px 13px",
              borderRadius: "30px",
            }}
          >
            {/* <ButtonLink 
              onClick={() => DrawerEditGroup(record)}
              style={{ color: "black" }}
            >
              {groupName}
            </ButtonLink> */}
            <span style={{ color: "black" }}>{groupName}</span>
          </div>
        );
      },
      filters: filterHDLR.getColumnsFilterGroup(group),
      onFilter: (value, record) => record.groupName === value,
    },
    {
      title: TABLE_EMPLOYEE_TITLE.Amount,
      key: TABLE_EMPLOYEE_INDEX.Amount,
      render: (record) => {
        const { eligAmount, owning } = record;

        const eligAmountInt = parseInt(eligAmount);

        const value = owning !== undefined ? owning : 0;
        const progressColor = getProgressColor(value, eligAmountInt);
        const progressValue = (value / eligAmountInt) * 100;

        const elig = eligAmount ? `RM${value} /RM${eligAmountInt}` : "";

        return exportState ? (
          eligAmount
        ) : (
          <Row align="middle" gutter={8}>
            <Col style={{ width: "100%" }}>
              RM {`${value} / ${eligAmountInt}`}
            </Col>
            <Col flex="auto" style={{ width: "45px" }}>
              <Progress
                percent={progressValue}
                strokeColor={progressColor}
                showInfo={false}
              />
            </Col>
          </Row>
        );
      },
      sorter: true,
    },
    ...(exportState
      ? [
          {
            title: TABLE_EMPLOYEE_TITLE.Owning,
            width: 200,
            render: (record) => {
              const { owning } = record;
              
              return exportState ? owning : <Text>{owning}</Text>;
            },
            ...searchHDLR.getColumnSearchProps("owning", handleSearch),
          },
        ]
      : []),
    {
      title: TABLE_EMPLOYEE_TITLE.Salary,
      key: TABLE_EMPLOYEE_INDEX.Salary,
      render: (record) => {
        const { baseSal } = record;

        return exportState ? baseSal : <>RM {baseSal} </>;
      },
      sorter: true,
    },
    {
      title: TABLE_EMPLOYEE_TITLE.Contact,
      key: TABLE_EMPLOYEE_INDEX.Contact,
      render: (record) => {
        const { contact } = record;

        const formattedContact = contact.replace(
          "+60",
          `<img src=${icon_malaysia} alt="Malaysia" style="width: 20px; height: 15px; border-radius: 50%; margin-right: 5px;"/>`
        );

        return exportState ? (
          contact
        ) : (
          <span dangerouslySetInnerHTML={{ __html: formattedContact }} />
        );
      },
      ...searchHDLR.getColumnSearchProps("contact", handleSearch),
    },
    {
      title: TABLE_EMPLOYEE_TITLE.Loyalty,
      // key: TABLE_EMPLOYEE_INDEX.Loyalty,
      render: (record) => {
        const { loyalty, loyaltyTier } = record;

        const loyaltyID =
          loyaltyTier && loyaltyTier.includes("LT") && loyaltyTier;

        const { tiers = {}, ltyid } = loyalty;
        const { name = "", discount = {} } = tiers[loyaltyID] || {};

        const tier = name
          ? `${ltyid}-${name} (${discount?.amount}${discount?.type})`
          : "";

        return exportState ? tier : <span>{tier}</span>;
      },
      // ...searchHDLR.getColumnSearchProps("coLty", handleSearch),
    },
    {
      title: TABLE_EMPLOYEE_TITLE.AppFreq,
      key: TABLE_EMPLOYEE_INDEX.AppFreq,
      width: 200,
      render: (record) => {
        const { pr_freq } = record;

        return exportState ? pr_freq : <>{pr_freq} Times</>;
      },
      sorter: true,
    },
    ...(!exportState
      ? [
          {
            title: TABLE_EMPLOYEE_TITLE.Bank_Name,
            key: TABLE_EMPLOYEE_INDEX.Bank_Name,
            width: 220,
            render: (record) => {
              const { bank_name, bank_acc, bank_holderName, bank_holderIc, ic } =
                record;
      
              const formattedBankHolderIc = formatIC(bank_holderIc);
              const formattedIc = formatIC(ic);
      
              const isBankHolderICMatchIC = formattedBankHolderIc === formattedIc;
      
              return (
                <>
                  <Row
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "180px",
                      textAlign: "left",
                    }}
                  >
                    <Col style={{ width: "30px" }}>{getBankIcon(bank_name)}</Col>
                    <Col>
                      {bank_name}
                    </Col>
                  </Row>
                  <Row
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "180px",
                      textAlign: "left",
                    }}
                  >
                    <Col style={{ width: "30px" }}>
                      {isBankHolderICMatchIC ? null : (
                        <Popover
                          content={
                            <>
                              <div>Bank holder name: {bank_holderName}</div>
                              <div>Bank holder IC: {formattedBankHolderIc}</div>
                            </>
                          }
                        >
                          <InfoCircleOutlined
                            style={{
                              color: "rgba(0,0,0,.45)",
                              marginRight: "10px",
                              cursor: "pointer",
                            }}
                          />
                        </Popover>
                      )}
                    </Col> 
                    <Col>
                      {bank_acc}
                      <br />
                    </Col>
                  </Row>
                </>
              );
            },
            ...searchHDLR.getColumnSearchProps("bank_name", handleSearch),
          },
        ]
      : []),
    ...(exportState
      ? [
          {
            title: TABLE_EMPLOYEE_TITLE.BankName,
            width: 200,
            render: (record) => {
              const { bank_name } = record;
              
              return exportState ? bank_name : <Text>{bank_name}</Text>;
            },
            ...searchHDLR.getColumnSearchProps("bank_name", handleSearch),
          },
          {
            title: TABLE_EMPLOYEE_TITLE.BankAcc,
            width: 200,
            render: (record) => {
              const { bank_acc } = record;
              
              return exportState ? bank_acc : <Text>{bank_acc}</Text>;
            },
            ...searchHDLR.getColumnSearchProps("bank_acc", handleSearch),
          },
          {
            title: TABLE_EMPLOYEE_TITLE.BankHolderName,
            width: 200,
            render: (record) => {
              const { bank_holderName } = record;
      
              const holderName = bank_holderName ? bank_holderName : "";
              
              return exportState ? holderName : <Text>{holderName}</Text>;
            },
            ...searchHDLR.getColumnSearchProps("holderName", handleSearch),
          },
          {
            title: TABLE_EMPLOYEE_TITLE.BankHolderIC,
            width: 200,
            render: (record) => {
              const { bank_holderIc } = record;
      
              const holderIC = bank_holderIc ? bank_holderIc : "";
              
              return exportState ? holderIC : <Text>{holderIC}</Text>;
            },
            ...searchHDLR.getColumnSearchProps("holderIC", handleSearch),
          },
        ]
      : []),
    {
      title: TABLE_EMPLOYEE_TITLE.Reference,
      key: TABLE_EMPLOYEE_INDEX.Reference,
      render: (record) => {
        const { empRefID } = record;

        return exportState ? empRefID : <>{empRefID} </>;
      },
      ...searchHDLR.getColumnSearchProps("empRefID", handleSearch),
    },
    {
      title: TABLE_EMPLOYEE_TITLE.CreatedAt,
      key: TABLE_EMPLOYEE_INDEX.CreatedAt,
      render: (record) => {
        const { createdBy, createdBy_name, createdAt } = record;
        const created = createdBy_name ? `${createdBy_name} /${createdBy}` : `${createdBy}`
        return exportState ? (
          `${created} - ${parseTimeMin(createdAt)}`
        ) : (
          <span>
            {created}
            <br />
            {parseTimeMin(createdAt)}
          </span>
        );
      },
      sorter: true,
    },
    {
      title: TABLE_EMPLOYEE_TITLE.UpdatedAt,
      key: TABLE_EMPLOYEE_INDEX.UpdatedAt,
      render: (record) => {
        const { updatedBy, updatedBy_name, updatedAt } = record;
        const updated = updatedBy ? `${updatedBy_name} /${updatedBy}` : "-"
        return exportState ? (
          `${updated} - ${parseTimeMin(updatedAt)}`
        ) : (
          <span>
            {updated}
            <br />
            {parseTimeMin(updatedAt)}
          </span>
        );
      },
      sorter: true,
    },
    {
      title: TABLE_EMPLOYEE_TITLE.Remarks,
      // key: TABLE_EMPLOYEE_INDEX.Remarks,
      width: 180,
      fixed: "right",
      render: (record) => {
        const { remarkCount } = record;

        return (
          <Badge
            count={remarkCount || 0}
            showZero
            offset={[10, 10]}
            color="#0E2483"
          >
            <ButtonLink
              onClick={() => {
                DrawerRemark(record);
              }}
            >
              <img src={icon_comment} alt="" />
            </ButtonLink>
          </Badge>
        );
      },
    },
  ];

  return columns;
};

// export const BULK_UPLOAD_REVIEW_COLUMN = () => {
//   const { TABLE_BULK_UPLOAD_INDEX, TABLE_EMPLOYEE_TITLE_BULK } =
//     TEMPLATE.EMPLOYEE;

//   return TABLE_BULK_UPLOAD_INDEX.map((index) => ({
//     title: TABLE_EMPLOYEE_TITLE_BULK[index],
//     key: index[0],
//     dataIndex: index[0],
//     editable: true,
//   }));
// };

export const BULK_UPLOAD_REVIEW_COLUMN = () => {
  const { TABLE_BULK_UPLOAD_INDEX, TABLE_EMPLOYEE_TITLE_BULK } =
    TEMPLATE.EMPLOYEE;

  return TABLE_BULK_UPLOAD_INDEX.map((index) => {
    // if(index[0] === "coid") {
    //   return {
    //     title: TABLE_EMPLOYEE_TITLE_BULK[index],
    //     key: index[0],
    //     editable: true,
    //     render: (record) => {
    //       return <span>{record?.coid}/ {record?.company_name}</span>
    //     },
    //   }
    // } else {
      return {
        title: TABLE_EMPLOYEE_TITLE_BULK[index],
        key: index[0],
        dataIndex: index[0],
        editable: true,
    }
  // }
});
};
